'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { parseAsInteger, useQueryStates } from 'nuqs';
import React, { useEffect, useMemo, useState, useTransition } from 'react';

import {
  isPriceLandingPage,
  useLandingAwareClear,
} from '../../hooks/useLandingAwareClear';
import { NewFilter } from '../new-filter/new-filter';
import { useQueryNonce, useResetPage } from '../utils';

import { Price } from './components/price/price';
import styles from './new-prices.module.scss';

export interface NewPricesProps {
  maxPrice: number;
  count: number;
  defaultMaxPrice?: number;
}

export const NewPrices: React.FC<NewPricesProps> = ({
  maxPrice,
  count,
  defaultMaxPrice,
}) => {
  const [_, startTransition] = useTransition();
  const landingAwareClear = useLandingAwareClear();
  const { generate } = useQueryNonce();
  const resetPage = useResetPage();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // const [mode, setMode] = useState<PriceModes>(PriceModes.price);

  const [queryPriceRange, setQueryPriceRange] = useQueryStates(
    {
      pricefrom: parseAsInteger.withDefault(0),
      priceto: parseAsInteger.withDefault(
        defaultMaxPrice ?? maxPrice,
      ),
    },
    {
      clearOnDefault: true,
      history: 'replace',
      shallow: false,
      startTransition,
    },
  );


  const [localRange, setLocalRange] = useState(() => ({
    min: queryPriceRange.pricefrom,
    max: queryPriceRange.priceto,
  }));

  useEffect(() => {
    setLocalRange({
      min: queryPriceRange.pricefrom,
      max: queryPriceRange.priceto,
    });
  }, [queryPriceRange.pricefrom, queryPriceRange.priceto]);

  const currentFilter = useMemo(
    () => ({
      min: localRange.min,
      max: localRange.max,
    }),
    [localRange],
  );

  const commitPrice = (val: { min: number; max: number }) => {
    if (
      val.min === queryPriceRange.pricefrom &&
      val.max === queryPriceRange.priceto
    ) {
      return;
    }

    resetPage();

    setQueryPriceRange({
      pricefrom: val.min,
      priceto: val.max,
    });

    generate();
  };

  return (
    <NewFilter
      label="Price"
      count={count}
      onClear={() => {
        const isSearchPage = pathname.includes('/search');
        const isPriceLanding = isPriceLandingPage(pathname);
        const hasPriceFilters =
          searchParams.has('pricefrom') ||
          searchParams.has('priceto');

        if (isSearchPage || hasPriceFilters) {
          setQueryPriceRange(null);
          generate();
          return;
        }

        if (isPriceLanding) {
          landingAwareClear('immediate');
        }
      }}
    >
      <div className={styles.priceFinanceWrapper}>
        {/* <div className={styles.priceFinanceTabsWrapper}> */}
          {/* <div
            onClick={() => setMode(PriceModes.price)}
            className={cx(styles.priceFinanceTab, {
              priceFinanceTabActive:
                mode === PriceModes.price,
            })}
          >
            Price
          </div>
          <div
            onClick={() => setMode(PriceModes.finance)}
            className={cx(styles.priceFinanceTab, {
              priceFinanceTabActive:
                mode === PriceModes.finance,
            })}
          >
            Finance
          </div> */}
        {/* </div> */}

        <Price
          defaultPriceFilter={{ min: 0, max: maxPrice }}
          currentFilter={currentFilter}
          onChange={setLocalRange}    
          onCommit={commitPrice}     
        />

        {/* {mode === PriceModes.finance && (
          <Finance
            initialDefaultPriceFilter={{
              min: 0,
              max: maxPrice,
            }}
            onSetFilter={(val) => {
              setLocalRange(val);
              commitPrice(val);
            }}
          />
        )} */}
      </div>
    </NewFilter>
  );
};
